import { Injectable } from '@angular/core';

import { TmsWebBaseImportService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ImportTranslationCacheService extends TmsWebBaseImportService {
  constructor() {
    // The second argument names the downloaded file (Translations.csv), so it is worded in the
    // user's language like the screen it comes from.
    super('ImportTranslationCache', $localize`Translations`);
  }
}
